var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScenarios(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00FFDC",
    d: "M12 0c1.105 0 2 .895 2 2v10c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V2c0-1.105.895-2 2-2h6zm-.833.778H6.833c-1.054 0-1.918.816-1.994 1.85l-.006.15v8.444c0 1.055.816 1.918 1.851 1.995l.15.005h4.333c1.054 0 1.918-.816 1.994-1.85l.006-.15V2.778c0-1.105-.896-2-2-2zM3.272 1v.75H1.818c-.513 0-.935.386-.993.883l-.007.117v8.5c0 .513.386.936.884.993l.116.007h1.454V13H2c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h1.272zM16 1c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2h-1.273v-.75h1.455c.513 0 .935-.386.993-.883l.007-.117v-8.5c0-.552-.448-1-1-1h-1.455V1H16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarios);
export default __webpack_public_path__ + "static/media/scenarios.5345b6f3c5c7b73ba872b401d38f978f.svg";
export { ForwardRef as ReactComponent };